/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Undertraining_NeutralInputs */

const en_coach_undertraining_neutral = /** @type {(inputs: Coach_Undertraining_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your readiness is balanced, but your weekly load has dropped well below your chronic average. Maintaining this level too long leads to deconditioning. A moderate increase would keep fitness on track.`)
};

const de_coach_undertraining_neutral = /** @type {(inputs: Coach_Undertraining_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Bereitschaft ist ausgeglichen, aber der Wochenumfang ist deutlich unter deinen Schnitt gerutscht. Auf Dauer führt das zu Fitnessverlust. Eine moderate Steigerung hält dich auf Kurs.`)
};

/**
* | output |
* | --- |
* | "Your readiness is balanced, but your weekly load has dropped well below your chronic average. Maintaining this level too long leads to deconditioning. A mode..." |
*
* @param {Coach_Undertraining_NeutralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_undertraining_neutral = /** @type {((inputs?: Coach_Undertraining_NeutralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Undertraining_NeutralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_undertraining_neutral(inputs)
	return de_coach_undertraining_neutral(inputs)
});